import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AolService, CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
import { LinkDocumentModal } from '../link-document-type-modal/link-document-type-modal.component';
import { PdfViewerService } from '../../services/pdfViewer';

interface IOtherTccRecordModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}

interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-other-tcc-record-modal',
  templateUrl: './other-tcc-record-modal.component.html',
  styleUrls: ['./other-tcc-record-modal.component.scss'],
})
export class OtherTccRecordModalComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('uploadDoc') uploadDoc: ElementRef;
  searchable: boolean = true;
  public mode: DatepickerMode = 'date';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  otherTCCForm: FormGroup;
  companyDirector: any;

  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  organizationId: string;
  currentForm: any;
  changeRequestId: string;
  heading: string;
  documentForm: FormGroup;
  selectedFile;
  fileNameArr: any = {};
  allFiles = [];
  uploadFormData: any;
  fileError;
  documentss: Document[];
  companyTypes;
  onFileChanges(event: any, document: Document): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const uploadedFiles: File[] = Array.from(fileList);
      document.uploadedFiles = document.uploadedFiles || [];
      document.uploadedFiles = [...document.uploadedFiles, ...uploadedFiles];
    }
    this.uploadedDocuments = this.documentss
      .filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      .map(({ uploadedFiles, ...rest }) => ({ ...rest, uploadedFiles }));
  }
  uploadedDocuments: any = [];
  removeDocument(index: number): void {
    this.documentss.splice(index, 1);
  }

  removeFile(document: Document, fileIndex: number): void {
    if (document.uploadedFiles) {
      document.uploadedFiles.splice(fileIndex, 1);
    }
  }
  removeLinkedDocument(doc, index) {
    if (doc) {
      this.allLinkedDocuments.splice(index, 1);
    }
  }
  editLinkedDocument(doc, index, data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Edit Selected existing documents from ${data} Document Type`,
          doc,
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        if (doc) {
          this.allLinkedDocuments[index] = documents[0];
        }
      })
      .onDeny(() => {});
  }
  editFile(event: any, document: Document, fileIndex: number): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const newFile: File = fileList[0];

      // Replace the existing file at the specified index
      if (document.uploadedFiles && document.uploadedFiles[fileIndex]) {
        document.uploadedFiles[fileIndex] = newFile;
      }
    }
  }

  onSubmit(): void {
    // Collect the uploaded documents for submission
    const uploadedDocuments = this.documentss.filter(
      (doc) => doc.uploadedFiles
    );

    // Send the uploadedDocuments array to your backend for further processing
    console.log('Uploaded Documents:', uploadedDocuments);
  }
  confirmedTin: boolean = false;
  proceedToSubmitTin: boolean = false;
  firsRecord;
  isBusinessName: boolean = false;
  documentUploaded: any = [];
  organization;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private aolService: AolService,
    public modal: SuiModal<IOtherTccRecordModalContext, void, void>,
    private pdfViewerService: PdfViewerService,
    private organizationSvc: OrganizationService,
    private documentSvc: DocumentService
  ) {
    this.companyType = modal.context.data.companyType;
    this.countries = modal.context.data.countries;
    this.ownershipType = modal.context.data.ownershipType;
    this.organizationId = window.localStorage.getItem('organizationId');
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.otherTCCForm = fb.group({
      tccNumber: ['', Validators.required],
      tccIssueDate: ['', Validators.required],
      tccExpiryDate: ['', Validators.required],
      taxOfficeName: ['', Validators.required],
      taxOfficeAddress: ['', Validators.required],
      year: ['', Validators.required],
      totalProfit: ['', Validators.required],
      assessableProfit: ['', Validators.required],
      turnOver: ['', Validators.required],
      taxPaid: ['', Validators.required],
    });
    this.documentForm = this.fb.group({
      file: [''],
      documentName: ['Doc', Validators.required],
      documentDescription: ['supporting document'],
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT'],
      documents: this.fb.array([]),
    });
    if (modal.context.isEdit) {
      // this.companyDirector = modal.context.data.director;
      // this.otherTCCForm.patchValue(this.companyDirector);
    }
    this.currentForm = this.otherTCCForm.value;
    this.getDocumentUploaded();
  }
  allLinkedDocuments: any = [];
  getTitle(title) {
    if (title === 'COMPANY_NAME') {
      return 'Change of Name';
    }
    if (title === 'RC_NUMBER') {
      return 'Change of Registration Details';
    }
    if (title === 'TIN') {
      return 'Change of TIN';
    }
    if (title === 'ADDRESS') {
      return 'Change of Address';
    }
    if (title === 'OTHER_TIN') {
      return 'Change of Other TIN';
    }
    if (title === 'CONTACT_INFORMATION') {
      return 'Change of Contact Information';
    }
  }
  LinkDocument(data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Select and link existing documents from ${data} Document Type`,
          '',
          data,
          this.uploads,
          ModalSize.Mini
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        documents.map((item) => this.allLinkedDocuments.push(item));
      })
      .onDeny(() => {});
  }

  returnDocumentType(data, id) {
    const filtered = data.filter((item) => {
      return item.documentTypeId.documentTypeName === id;
    });
    return filtered;
  }

  uploads: any = [];
  getDocumentUploaded() {
    this.pending = true;
    this.aolService
      .getDocumentUpload({
        optionId: 'other_tcc',
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.uploads = res.filter((item) => item.isActive);
          console.log(this.uploads, 'this.uploads');
          this.documentss = this.uploads.map((doc) => ({
            ...doc,
            uploadedFiles: [],
          }));
          console.log(this.documentss, 'document');
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  get documents() {
    return this.documentForm.controls['documents'] as FormArray;
  }
  viewDocument(data: any) {
    this.pdfViewerService.viewPdf(data);
  }
  removeDocSegment(index: number) {
    this.documents.removeAt(index);
  }
  isFieldValid(field: string) {
    return (
      (!this.otherTCCForm.get(field).valid &&
        this.otherTCCForm.get(field).touched) ||
      (this.otherTCCForm.get(field).untouched && this.formSubmitAttempt)
    );
    return (
      (!this.documentForm.get(field).valid &&
        this.documentForm.get(field).touched) ||
      (this.documentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submit() {
    // this.modal.context.isEdit == true
    //   ? this.updateDirector('UPDATE')
    //   : this.save();
  }

  printForm() {
    console.log(this.otherTCCForm.valid, this.otherTCCForm.value);
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.otherTCCForm.valid) {
      this.pending = true;
      let data = this.otherTCCForm.value;
      data['organizationId'] = this.organizationId;
      this.companySvc
        .updateCompanyDirector({
          organizationId: this.organizationId,
          id: this.companyDirector.organizationOwnershipId,
          body: { ...this.companyDirector, ...data },
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company director updated successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  // update form
  updateDirector(val) {
    let data: any = this.uploadedDocuments;
    if (data && data.length > 0) {
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const size = document.size;
          if (size > 10 * 1024 * 1024) {
            this.error = `File (${document.name}) size is too large, Maximum file size is 10MB`;
            return;
          }
        }
      }
    }
    if (this.uploadedDocuments.length > 0) {
      this.checkDoc();
    } else if (this.allLinkedDocuments.length > 0) {
      this.save();
    } else {
      // this.input.nativeElement.focus();
      // this.h3.nativeElement.focus();
      // this.error = 'Please upload the required Document';
      this.save();
    }
  }
  allDocuments: any = [];
  checkDoc() {
    this.formSubmitAttempt = false;
    if (this.uploadedDocuments.length > 0) {
      let data: any = this.uploadedDocuments;
      console.log(data, 'data');
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const formData: FormData = new FormData();
          const file = document;
          formData.append('file', file);
          let formValue = {
            documentDescription: 'supporting document',
            documentName: documentType.documentTypeName,
            documentTypeId: documentType.documentTypeId,
          };
          let payload: any = { formValue: formValue, formData: formData };
          this.allDocuments.push(payload);
        }
      }
      console.log(this.allDocuments, 'new');
      this.allDocuments.map((item, index) => {
        this.processUpload(item, index);
      });
    } else {
      this.formSubmitAttempt = true;
    }
  }
  processUpload(data, i) {
    let uploadFormData = data['formData'];
    const values = data['formValue'];
    const jsonse = JSON.stringify(values);
    const blob = new Blob([jsonse], { type: 'application/json' });
    uploadFormData.append('data', blob);
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({
        organizationId: this.organizationId,
        body: uploadFormData,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.documentUploaded.push(res);
          if (i + 1 === this.allDocuments.length) {
            console.log(this.documentUploaded, 'this.documentUploaded');
            this.save();
            // console.log(index, this.allDocuments.length, 'before');
          }
        },
        (error) => {
          this.pending = false;
          this.error =
            'Error while uploading Utility Bills (Water Board, PHCN)';
        }
      );
  }
  save() {
    this.pending = true;
    this.nullify();
    let emptyArray = [];
    this.allLinkedDocuments.map((item) => emptyArray.push(item));
    this.documentUploaded.map((item) => emptyArray.push(item));
    let requiredDocument = this.uploads.filter((item) => {
      return item['isRequired'];
    });
    const documentTypeIdSet = new Set(
      emptyArray.map((item) => item.documentTypeId?.documentTypeId)
    );
    console.log(documentTypeIdSet, requiredDocument, 'idSet');
    const objectsNotInSecondArray = requiredDocument.filter(
      (item) => !documentTypeIdSet.has(item.documentTypeId)
    );
    console.log(objectsNotInSecondArray, 'object');
    if (objectsNotInSecondArray.length > 0) {
      this.pending = false;
      this.error = 'Please upload the required Document';
      return;
    } else {
      this.otherTCCForm.value.documents = emptyArray;
    }
    let payload = {
      organization: {
        organizationId: this.organization.organizationId,
      },
      changeRequestType: 'OTHER_TCC',
      actionType: 'ADD',
      fromValue: JSON.stringify(this.currentForm),
      toValue: JSON.stringify(this.otherTCCForm.value),
    };
    this.organizationSvc
      .addChangeRequest({
        organizationId: this.organization.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.changeRequestId = res['changeRequestId'];
          setTimeout(() => {
            this.pending = false;
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
    // return '';
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  createDocument() {
    const docForm = this.fb.group({
      document: [null, Validators.required],
    });

    this.documents.push(docForm);
    this.uploadDoc.nativeElement.focus();
  }
  onFileChange(event, ind) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
    this.fileNameArr[ind] = this.selectedFile['name'];
    this.allFiles.push(this.selectedFile);
  }
  submitDoc(response) {
    this.formSubmitAttempt = false;
    if (this.fileError == null) {
      let data: any = this.documentForm.value;
      // this.allFiles.map(file => {})
      const formData: FormData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      let payload: any = { formValue: data, formData: formData };
      // this.modal.approve(payload);

      this.uploadFormData = payload['formData'];
      const values = payload['formValue'];
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this.onUploadFile(this.uploadFormData, response);
    } else {
      this.formSubmitAttempt = true;
    }
  }

  onUploadFile(data, response) {
    this.nullify();
    this.pending = true;
    let result: any = {
      fromValue: response.fromValue,
      toValue: response.toValue,
      document: data,
    };
    this.input.nativeElement.focus();
    this.success =
      'Update Successful. Ensure you save so that the request can undergo verification';
    setTimeout(() => {
      this.modal.approve(result);
    }, 2000);
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class OtherTccRecordModal extends ComponentModalConfig<
  IOtherTccRecordModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(OtherTccRecordModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
